import jwtDecode from 'jwt-decode';
import { CustomJwtPayload, TokenWithPayload } from '../interfaces/token-with-payload.interface';

export interface TokenPairWithPayload {
	access: TokenWithPayload | null;
	refresh: TokenWithPayload | null;
}

export const createTokenPair = (access?: string | null, refresh?: string | null): TokenPairWithPayload => {
	try {
		if (!access || !refresh) {
			return {
				access: null,
				refresh: null
			};
		}

		const accessPayload = jwtDecode<CustomJwtPayload>(access);
		const refreshPayload = jwtDecode<CustomJwtPayload>(refresh);

		return {
			access: {
				token: access,
				payload: accessPayload
			},
			refresh: {
				token: refresh,
				payload: refreshPayload
			}
		};
	} catch {
		return {
			access: null,
			refresh: null
		};
	}
};

export const isTokenExpired = (payload: CustomJwtPayload): boolean => {
	const exp = payload.exp ?? 0;

	return new Date().getTime() >= exp * 1000;
};
